export default __webpack_public_path__ + "privacypolicy.4f064301.svg";